<template>
  <i :class="['ehf-icon', 'ri-' + icon]" aria-hidden="true"></i>
</template>

<script>
  export default {
    name: 'EhfIcon',
  }
</script>

<script setup>
  defineProps({
    icon: {
      type: String,
      required: true,
    },
  })
</script>

<style lang="scss" scoped>
  [class*='ri'] {
    font-size: 16px;
    vertical-align: -1px;
  }
</style>
